var _path, _path2, _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSteadiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6966",
    "data-name": "Group 6966",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.917,
    height: 10.672,
    viewBox: "0 0 23.917 10.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-left",
    "data-name": "Icon awesome-long-arrow-alt-left",
    d: "M3.752,14.459H12.2a.336.336,0,0,0,.336-.336V12.556a.336.336,0,0,0-.336-.336H3.752V10.931a.672.672,0,0,0-1.147-.475L.2,12.865a.672.672,0,0,0,0,.95l2.409,2.409a.672.672,0,0,0,1.147-.475Z",
    transform: "translate(11.379 -5.749)",
    fill: "#2e117f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-right",
    "data-name": "Icon awesome-long-arrow-alt-right",
    d: "M9.674,12.418H.37a.37.37,0,0,0-.37.37v1.726a.37.37,0,0,0,.37.37h9.3V16.3a.74.74,0,0,0,1.263.523l2.652-2.652a.74.74,0,0,0,0-1.046l-2.652-2.652A.74.74,0,0,0,9.674,11Z",
    transform: "translate(0 -10.258)",
    fill: "#2e117f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1267",
    "data-name": "Rectangle 1267",
    width: 6.693,
    height: 0.669,
    rx: 0.335,
    transform: "translate(16.063 1.931)",
    fill: "#2e117f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1270",
    "data-name": "Rectangle 1270",
    width: 6.693,
    height: 0.669,
    rx: 0.335,
    transform: "translate(2.008 6.614)",
    fill: "#2e117f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1268",
    "data-name": "Rectangle 1268",
    width: 6.693,
    height: 0.669,
    rx: 0.335,
    transform: "translate(16.063 3.938)",
    fill: "#2e117f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1269",
    "data-name": "Rectangle 1269",
    width: 6.693,
    height: 0.669,
    rx: 0.335,
    transform: "translate(2.008 7.954)",
    fill: "#2e117f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteadiness);
export default __webpack_public_path__ + "static/media/steadiness.2c70d72b4298b522c27ea4d1bf3a9907.svg";
export { ForwardRef as ReactComponent };